enum StatusInventario {
    Ativo = 0,
    Cancelado = 1,
    Concluido = 2
}

export default StatusInventario;